import { useIsRibbonSidebarEnabled } from '@/app-shell/flags/agents-flags';
import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar';
import { trackTemplateLibraryViewed } from '@/lib/analytics/scribe/template';
import { SidebarMenu } from '@heidi/design-system/page-shell';
import { Globe } from 'lucide-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  templates: {
    defaultMessage: 'Templates',
    id: 'dUi/R6WKwd',
    description: 'Sidebar nav entry linking to the template library',
  },
});

export interface TemplateGroupNavItemsProps {
  startTransition: (fn: () => void) => void;
  closeSidePanels: () => void;
  shouldHighlightCommunity: boolean;
  onNextPage: () => void;
  isTemplatesActive: boolean;
}

export function TemplateGroupNavItems({
  startTransition,
  closeSidePanels,
  shouldHighlightCommunity,
  onNextPage,
  isTemplatesActive,
}: TemplateGroupNavItemsProps) {
  const intl = useIntl();
  const { dismissMobileSidebar } = useMobilePanel();
  const isRibbonSidebarEnabled = useIsRibbonSidebarEnabled();

  return (
    <SidebarMenu>
      {!isRibbonSidebarEnabled && (
        <NavItem
          label={intl.formatMessage(messages.templates)}
          icon={<Globe />}
          href="/templates"
          isActive={isTemplatesActive}
          onClick={() => {
            startTransition(() => {
              trackTemplateLibraryViewed();
              closeSidePanels();
              if (shouldHighlightCommunity) {
                onNextPage();
              }
            });
            dismissMobileSidebar();
          }}
          testId="sidebar-link-templates"
        />
      )}
    </SidebarMenu>
  );
}
